import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DialogModel} from '@shared/models/dialog.model';
import {SnackBarService} from '@core/services/snack-bar.service';
import {takeUntil} from 'rxjs/operators';
import {FirmApiService} from '../../services/firm-service';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-edit-packages-dialog',
  templateUrl: './edit-packages-dialog.component.html',
  styleUrls: ['./edit-packages-dialog.component.scss']
})
export class EditPackagesDialogComponent implements OnInit, IDialogView, OnDestroy {
  inputForm: FormGroup;
  data: DialogModel;
  unsubscribe$: Subject<void> = new Subject<void>();
  subAccountPackages = [];

  constructor(private formBuilder: FormBuilder,
              private firmService: FirmApiService,
              private snackBarService: SnackBarService) {
  }

  ngOnInit() {
    const currentPackages: string[] = this.data?.input?.currentPackages ?? [];
    this.inputForm = this.formBuilder.group({
      packages: [currentPackages, Validators.required]
    });

    this.firmService.getSubAccountPackages().pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state && state.length > 0) {
        this.subAccountPackages = state;
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onOkClicked(): boolean {
    if (!this.inputForm.valid) {
      this.snackBarService.showError('Please select at least one package.');
      return false;
    }
    this.data.input.packages = this.inputForm.controls['packages'].value;
    return true;
  }
}
